export { default } from './Pagination';



// WEBPACK FOOTER //
// ./src/components/molecules/Pagination/index.js